<template>
  <vs-popup
    :title="$t('SelectAdmin') + ' ' + model.salePersonName"
    :active.sync="popupActive"
  >
    <div>
      <div class="vx-row mb-2">
        <div class="vx-col lg:w-1/3 w-full">
          <label class="vs-select--label">{{ $t("AdminName") }}</label>
          <vs-input
            name="AdminName"
            v-model="adminName"
            @keyup.enter="searchAdminName()"
          />
        </div>
        <div class="vx-col lg:w-1/6 w-full">
          <vs-button
            class="mt-6 p-2"
            color="success"
            type="gradient"
            icon-pack="feather"
            icon="icon-search"
            @click.prevent="searchAdminName()"
          ></vs-button>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full mb-base">
          <data-grid
            ref="grid"
            stripe
            :data-source="gridDataSource"
            :search-data="gridSearchData"
            :columns="[
              { title: $t('AdminName') },
              { title: $t('UserId'), sort: 'UserId' },
              { title: $t('Action'), sort: 'Action' },
            ]"
          >
            <template slot-scope="{ row }">
              <td style="width: 40%">
                {{ row.userName }}
              </td>
              <td style="width: 20%">
                {{ row.id }}
              </td>

              <td style="width: 20%">
                <vs-button
                  radius
                  color="success"
                  size="small"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-plus"
                  @click.prevent="addAdminToSalePerson(row)"
                  class="ml-4 d-inline"
                ></vs-button>
              </td>
            </template>
          </data-grid>
        </div>
      </div>
    </div>
  </vs-popup>
</template>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import { mapActions } from "vuex";
export default {
  name: "",
  props: {
    show: { default: false },
    model: {
      default: {},
    },
  },
  data() {
    return {
      gridDataSource: {},
      gridSearchData: {
        UserName: "",
      },
      adminName: "",
      modelForAssign: {},
    };
  },
  computed: {
    popupActive: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  components: {
    DataGrid,
  },
  methods: {
    ...mapActions({
      assignAdmin: "sale/attachAdminInfo",
    }),
    searchAdminName() {
      this.gridSearchData.UserName = this.adminName;
      this.$refs.grid.renderGrid();
    },
    addAdminToSalePerson(adminSelected) {
      this.modelForAssign.id = this.model.salePersonId;
      this.modelForAssign.adminId = adminSelected.id;
      this.modelForAssign.adminUserName = adminSelected.userName;
      this.assignAdmin(this.modelForAssign).then(() => {
        this.adminName = "";
        this.gridSearchData.UserName = "";
        this.$emit("finish");
      });
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.gridDataSource = {
          type: "app",
          service: "IdentityAccess/api/UsersQuery",
        };
        setTimeout(() => {
          this.$refs.grid.renderGrid();
        }, 200);
      }
    },
  },
};
</script>
